export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/7a143c79cdc7d4c413ea4cb40505b1e6.png";